import * as ms from 'milliseconds';
import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { MBAnimation } from '@shared/components/animation';
import { MBChatInputMentionList, MBChatInputMentionListProps } from './index';

interface Props extends MBChatInputMentionListProps {
  style: StyleProp<ViewStyle>;
}

export function MBChatInputMentionListWithAnimation({ style, ...listProps }: Props) {
  const visible = !!listProps.users.length || !!listProps.groups.length;
  if (!visible) {
    return null;
  }
  return (
    <MBView style={style} paddingHorizontal={1.25} paddingBottom={0.625}>
      <MBAnimation
        opacity={{ from: 0, to: 1 }}
        translateY={{ from: 100, to: 0 }}
        duration={ms.seconds(0.2)}
      >
        <MBChatInputMentionList {...listProps} />
      </MBAnimation>
    </MBView>
  );
}
